export default __webpack_public_path__ + "static/Pharmaceutical-704e92eb25de015eda5efd3fabdf8e95.jpg";